export default __webpack_public_path__ + "6355f7eb46c53cf484c02b8da6b75738.png";